import { createContext } from 'react';
/**
 * __Spacing context__
 *
 *  The spacing context is used to provide spacing values to menu item primitives.
 *
 * @internal Do not use directly.
 */
export var SpacingContext = /*#__PURE__*/createContext('cozy');

/**
 * __Selection context__
 *
 * The selection context is used to set what selection mode the menu items display as.
 *
 * @internal Do not use directly.
 */
export var SELECTION_STYLE_CONTEXT_DO_NOT_USE = /*#__PURE__*/createContext('border');